import { render, staticRenderFns } from "./KioskTerms.vue?vue&type=template&id=2b6f4e6d&scoped=true"
import script from "./KioskTerms.vue?vue&type=script&lang=js"
export * from "./KioskTerms.vue?vue&type=script&lang=js"
import style0 from "./KioskTerms.vue?vue&type=style&index=0&id=2b6f4e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f4e6d",
  null
  
)

export default component.exports